/**
 * Notification service configuration
 * Modify these settings to control notification behavior and API calls
 */
const NOTIFICATION_CONFIG = {
  // API Control Settings
  enableSalesOrdersAPI: true,     // Set to false to disable sales orders API calls
  enablePurchaseOrdersAPI: true,  // Set to false to disable purchase orders API calls
  enableLowStockAPI: true,        // Set to false to disable low stock API calls
  enableNotificationsAPI: true,   // Set to false to disable main notifications API calls
  
  // Polling Settings
  pollingInterval: 60000,         // 60 seconds - how often to poll for notifications
  cacheExpiry: 60000,            // 60 seconds - how long to cache notification data
  additionalDataInterval: 120000, // 2 minutes - how often to fetch sales orders and low stock data
  
  // Circuit Breaker Settings
  maxRetries: 3,                 // Maximum retries before circuit breaker activates
  circuitBreakerTimeout: 300000, // 5 minutes - timeout for circuit breaker
  requestTimeout: 10000,         // 10 seconds - timeout for individual API requests
  
  // Fallback Settings
  useFallbackData: true,         // Whether to use cached/fallback data when APIs fail
  showErrorNotifications: false, // Whether to show error notifications to users
  
  // Debug Settings
  enableDebugLogging: false,     // Enable detailed debug logging
  logAPIErrors: true,           // Log API errors to console
};

export default NOTIFICATION_CONFIG; 